module.exports = __webpack_public_path__ + "Example-Audience-Vote.png?e8e8a54161b7d1e76108fe2a16d91ea5";


//////////////////
// WEBPACK FOOTER
// ./static/Example-Audience-Vote.png
// module id = 350
// module chunks = 0